"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshTokenAsync = exports.isLoadingRefreshToken = void 0;
const axios_1 = __importDefault(require("axios"));
const token_1 = require("./token");
const user_1 = require("./user");
exports.isLoadingRefreshToken = false;
const refreshTokenAsync = () => {
    const token = (0, token_1.getToken)();
    if (!token) {
        (0, token_1.setBearer)(null);
        return Promise.reject();
    }
    exports.isLoadingRefreshToken = true;
    return (0, axios_1.default)({
        method: 'post',
        url: '/refresh',
        data: { token: token.refreshToken },
        headers: {
            Authorization: null
        },
    }).then((response) => {
        if (!response.data)
            return response;
        const { user, accessToken, refreshToken, expiresIn } = response.data;
        (0, token_1.saveToken)({ accessToken, refreshToken, expiresIn });
        (0, user_1.saveUserLS)(user);
        return response;
    }).finally(() => {
        exports.isLoadingRefreshToken = false;
    });
};
exports.refreshTokenAsync = refreshTokenAsync;
